export const normalizeSlotPath = (path: string): string => {
    if (!path) return '/'

    return path.startsWith('/') ? path : `/${path}`
}

export const normalizeRoomName = (roomName: string): string => roomName.replace(/^\/+/, '')

export const buildWebsocketDebugUrl = (baseWsUrl: string, slotPath: string): string => {
    const base = baseWsUrl.replace(/\/+$/, '')

    return `${base}/${slotPath}`
}
